import {
  SET_HO_LOAN_FOCUS,
  SET_HO_CHECKED_NUMBERS,
  SET_WARNING_MODAL_VISIBLE
} from './actionTypes'
import { isBoolean } from 'lodash'
import { scrollToElement } from 'src/helpers/browser'
import { getRef } from 'src/store/elementReference'
import { MortgagesPanel } from 'src/constants/notificationRefs'
import { updateHomeLoan } from 'src/actions/home'
import { saveClientAnswer } from 'src/actions/client'
import { QUESTION_ACKNOWLEDGED_TUNE_VALUE } from 'src/constants/valuation'
import {
  getLoanTermYears,
  getLoanInterestRate
} from 'src/store/selectors/home/loans'
import { hasCustomerToken } from 'src/auth'
import { PREFERENCES } from 'src/constants/messages'

const toggleLoans = (loanFocus, options = {}) => (dispatch, getState) => {
  const { loanFocus: current } = getState().homeowner

  if (loanFocus === current) {
    return
  }

  if (loanFocus) {
    const { current: ref } = getRef(MortgagesPanel)
    scrollToElement(ref)
  }

  dispatch({
    type: SET_HO_LOAN_FOCUS,
    loanFocus,
    disableAnimateLoanFocus: options.disableAnimate
  })
}

export const openLoans = () => toggleLoans(true)

export const closeLoans = () => toggleLoans(false)

export const closeLoansNow = () => toggleLoans(false, { disableAnimate: true })

export const markLoansChecked = loans => async dispatch => {
  dispatch({
    type: SET_HO_CHECKED_NUMBERS
  })

  if (loans) {
    const confirmedLoans = loans.map(loan => ({
      id: loan.id,
      homeId: loan.homeId,
      rate: getLoanInterestRate(loan),
      termYears: getLoanTermYears(loan)
    }))
    await Promise.all(
      confirmedLoans.map(loan => updateHomeLoan(loan)(dispatch))
    )
  }
}

export const toggleWarningModal = showWarningModal => (dispatch, getState) => {
  const { showWarningModal: current } = getState().homeowner

  dispatch({
    type: SET_WARNING_MODAL_VISIBLE,
    showWarningModal: isBoolean(showWarningModal) ? showWarningModal : !current
  })
}

export const handleAcknowledgeTuneValue = () => async dispatch => {
  dispatch(
    saveClientAnswer({
      question: QUESTION_ACKNOWLEDGED_TUNE_VALUE,
      response: {
        value: true
      }
    })
  )
}

export const handleAcknowledgeTeaser = (
  question,
  value,
  notify
) => async dispatch => {
  dispatch(
    saveClientAnswer(
      {
        question,
        response: {
          value
        }
      },
      notify && {
        successMessage: PREFERENCES.saved,
        failureMessage: PREFERENCES[hasCustomerToken() ? 'duh' : 'errored']
      }
    )
  )
}
